/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_lumpsum_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How often does this calculator compound interest?`)
};

const es_sip_lumpsum_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Con qué frecuencia esta calculadora compone interés?`)
};

const de_sip_lumpsum_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie oft zerlegt dieser Rechner Zinsen?`)
};

const nl_sip_lumpsum_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe vaak werkt deze calculator rentekapitalisatie?`)
};

const fr_sip_lumpsum_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À quelle fréquence ce calculateur compose-t-il les intérêts ?`)
};

const it_sip_lumpsum_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con quale frequenza questo calcolatore capitalizza l'interesse?`)
};

const pt_br2_sip_lumpsum_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com que frequência esta calculadora compõe juros?`)
};

const pt_sip_lumpsum_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com que frequência esta calculadora capitaliza o juro?`)
};

const ja_sip_lumpsum_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この計算機はどのくらいの頻度で複利計算されますか？`)
};

const zh_sip_lumpsum_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此计算器多久复利一次？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_lumpsum_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_lumpsum_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_lumpsum_faq3_q", locale)
	if (locale === "en") return en_sip_lumpsum_faq3_q(inputs)
	if (locale === "es") return es_sip_lumpsum_faq3_q(inputs)
	if (locale === "de") return de_sip_lumpsum_faq3_q(inputs)
	if (locale === "nl") return nl_sip_lumpsum_faq3_q(inputs)
	if (locale === "fr") return fr_sip_lumpsum_faq3_q(inputs)
	if (locale === "it") return it_sip_lumpsum_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_lumpsum_faq3_q(inputs)
	if (locale === "pt") return pt_sip_lumpsum_faq3_q(inputs)
	if (locale === "ja") return ja_sip_lumpsum_faq3_q(inputs)
	return zh_sip_lumpsum_faq3_q(inputs)
};